module.exports = __webpack_public_path__ + "static/media/creditcard.904a6125.svg";